import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { AXIOS } from '../api'
import { useDispatch, useSelector } from 'react-redux'
import Switch from "react-switch"
import { Link } from 'react-router-dom'
import { Icon, Button, Box, Text, Icons, PictureItem } from './common/Themes'

import { setFetch, setLoading } from '../redux/actions'

const CodePromo = () => {

    const dispatch = useDispatch()
    const { articles: ARTICLES, codepromos } = useSelector(state => state.fetch)
    const { fetch } = useSelector(state => state.config)
    const [codepromosFill, setCodepromosFill] = useState([])

    useEffect(() => {
        setCodepromosFill(codepromos)
    }, [codepromos]);

    const changeStatusHandler = async (pid, status) => {
        try {
            dispatch(setLoading(true))
            await AXIOS.patch(`/api/v1/codepromos/${pid}`, { status })
            dispatch(setFetch(!fetch))
            dispatch(setLoading(false))
        } catch (error) {
            console.log(error)
        }
    }

    const handleChange = e => setCodepromosFill(codepromos.filter(({ name }) => name?.toLocaleLowerCase().includes(e.target.value?.toLocaleLowerCase())))

    const deleteHandler = async pid => {
        try {
            dispatch(setLoading(true))
            await AXIOS.delete(`/api/v1/codepromos/${pid}`)
            dispatch(setFetch(!fetch))
            dispatch(setLoading(false))
        } catch (error) {
            console.log(error)
        }
    }

    const gestionItem = (pid, label, percentage, start, end, status, color, articles) => {
        let names = []
        ARTICLES.map(({ id, name }) =>
            articles.split(',').map(article => {
                if (id == article) names.push(name)
            })
        )
        return (
            <Box key={pid}>
                <Text color={color} style={{ width: '130px', textTransform: 'none' }}>{label}</Text>
                <Text color={color} style={{ width: '50px' }}>{percentage}</Text>
                <Text color={color} style={{ width: '110px' }}>{moment(start).format('D/MM/YYYY')}</Text>
                <Text color={color} style={{ width: '110px' }}>{moment(end).format('D/MM/YYYY')}</Text>
                <Text color={color} style={{ flexGrow: 3, padding: '0 20px', fontSize: '12px', height: '57.4px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', overflow: 'auto', position: 'relative' }}><div style={{ position: 'absolute', top: '0' }}>{names.map((name, index) => <div key={index}>{`${index + 1} - ${name.split(' - ').length > 1 ? name.split(' - ')[1] : name}`}</div>)}</div></Text>
                <div style={{ overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: '1', margin: '0 1.2rem 0 3rem' }}>
                    <Switch checked={status} onColor={color} onChange={() => changeStatusHandler(pid, !status)} />
                </div>
                <Link to={`/codepromos/${pid}`} style={{ height: '2.2rem' }}>
                    <Icons color={color} style={{ margin: '0 1.2rem' }}>
                        <use xlinkHref="/img/sprite.svg#icon-edit"></use>
                    </Icons>
                </Link>
                <Icons onClick={() => deleteHandler(pid)} color={color} style={{ margin: '0 1.2rem' }}>
                    <use xlinkHref="/img/sprite.svg#icon-bin2"></use>
                </Icons>
            </Box>
        );
    }

    return (
        <div className="gestion">
            <div className="gestion__header" style={{ marginBottom: '5rem' }}>
                <h4 className="gestion__title">Gestion Code Promo</h4>
                <h5 className="gestion__total">{codepromosFill.length} Total</h5>

                <div style={{ marginLeft: 'auto', display: 'flex', position: 'relative' }}>
                    <input onChange={() => handleChange()} name="search" className="gestion__input" placeholder="Rechercher" />
                    <Icons color="#B0BAC9" style={{ margin: '1rem', position: 'absolute', right: '1rem' }}>
                        <use xlinkHref="/img/sprite.svg#icon-search"></use>
                    </Icons>
                </div>
            </div>
            <Button to='/codepromo' color={'#FF5C00'} style={{ display: 'flex', justifyContent: 'center' }}>
                <Icons color={'#fff'} style={{ margin: '0 1rem 0 0', width: '16px' }}>
                    <use xlinkHref="/img/sprite.svg#icon-plus"></use>
                </Icons>
                Nouveau
            </Button>
            <div className="gestion__content">
                <div className="gestion__listheader">
                    {/* <div className="gestion__headerItem" style={{ width: '79px' }}></div> */}
                    <div className="gestion__headerItem" style={{ width: '130px' }}>Label</div>
                    <div className="gestion__headerItem" style={{ width: '50px' }}>%</div>
                    <div className="gestion__headerItem" style={{ width: '110px' }}>date de début</div>
                    <div className="gestion__headerItem" style={{ width: '110px' }}>date de fin</div>
                    <div className="gestion__headerItem" style={{ width: '320px' }}>articles</div>
                    {/* <div className="gestion__headerItem" style={{ width: '41px' }}></div> */}
                </div>
                <div className="gestion__list">
                    {codepromosFill.map(({ pid, label, percentage, start, end, status, color, articles }) => gestionItem(pid, label, percentage, start, end, status, color, articles))}
                </div>
                <Link to='/codepromo' style={{ alignSelf: 'center' }}>
                    <Icon color={'#FF5C00'} style={{ marginBottom: '0' }}>
                        <use xlinkHref="/img/sprite.svg#icon-plus-alt"></use>
                    </Icon>
                </Link>
            </div>
        </div>
    );
}

export default CodePromo